import {Carousel} from "react-bootstrap";
import React from "react";

interface Props {
    images?: string[],
    isMobile?: boolean,
}

export const CarouselWrapper: React.FunctionComponent<Props> = (props) => {
    return props.images && props.images.length ? 
        props.images.length <= 1 ?
            <div style={{
                width: props.isMobile ? '147px' : '220px',
                height: '147px',
                backgroundColor: '#d8d8d8',
                backgroundImage: `url("${props.images && props.images[0] || props.images || ''}")`,
                backgroundSize: 'cover'
            }}/>
            : <Carousel
                slide={false}
            >
                {props.images.map((imageName, i) => <Carousel.Item style={{
                    width: props.isMobile ? '147px' : '220px',
                    height: '147px',
                    backgroundColor: '#d8d8d8',
                    backgroundImage: `url("${imageName}")`, // TODO: need to handle HTTPS
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }} key={i}/>)}
            </Carousel>
        : <div style={{
            width: props.isMobile ? '147px' : '220px',
            height: '147px',
            backgroundColor: '#d8d8d8',
            // backgroundImage: `url("http://128.199.67.222:8081/ads/image/key?key=${image}")`,
            backgroundSize: 'cover'
        }}/>
};

